import http from "@/utils/request";
// 系统主题查询
export const getSystem_theme = (params) => {
  // 返回一个promise对象
  return http.get("/Cust_info/GetTheme", params);
};
// 系统主题保存
export const SaveSystem_theme = (data) => {
  // 返回一个promise对象
  return http.post("/Cust_info/SetTheme", data);
};
